<template>
  <span style="display: inline-block" persistent>
    <v-btn class="mx-1" color="primary" @click="show = true">Copy Template Flow</v-btn>
    <v-dialog v-model="show" max-width="1000">
      <v-card>
        <div class="text-xs-right">
          <v-btn fab flat small :loading="loading" @click="onclose">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <v-stepper v-model="step" vertical class="elevation-0">
            <v-stepper-step step="1">
              Select page
            </v-stepper-step>

            <v-stepper-content step="1">
              <v-card class="mb-5 elevation-0">
                <v-select
                  v-model="page"
                  item-text="botname"
                  item-value="botorigin"
                  :items="pagelist"
                  label="Copy to"
                  outline
                  hide-details
                  :loading="loading"
                ></v-select>
              </v-card>
              <v-btn flat :loading="loading">Cancel</v-btn>
              <v-btn color="primary" @click="step = 2" :disabled="!page" :loading="loading"
                >Continue</v-btn
              >
            </v-stepper-content>

            <v-stepper-step step="2">
              Select template flow
            </v-stepper-step>

            <v-stepper-content step="2">
              <v-card class="mb-5 elevation-0">
                <v-treeview
                  v-model="tree"
                  :load-children="getAllFlow"
                  :items="items"
                  activatable
                  active-class="grey lighten-4 indigo--text"
                  selected-color="primary"
                  open-on-click
                  selectable
                  expand-icon="arrow_drop_down"
                  on-icon="check_box"
                  off-icon="check_box_outline_blank"
                  indeterminate-icon="indeterminate_check_box"
                >
                  <template v-slot:label="{ item }">
                    {{ item.name }}<span class="ml-2 grey--text">{{ item.description }}</span>
                  </template>
                </v-treeview>
              </v-card>
              <v-btn flat @click="step = 1">Back</v-btn>
              <v-btn color="primary" @click="step = 3" :disabled="filterflow.length == 0"
                >Continue</v-btn
              >
            </v-stepper-content>

            <v-stepper-step step="3">
              Confirm Copy
            </v-stepper-step>

            <v-stepper-content step="3">
              <v-card class="mb-5 elevation-0">
                Copy {{ filterflow.length }} flows to "{{
                  currentPage ? currentPage.botname : '-'
                }}" page
              </v-card>
              <v-btn flat @click="step = 2" :loading="loading">Back</v-btn>
              <v-btn color="primary" @click="oncomplete" :loading="loading">Copy</v-btn>
            </v-stepper-content>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { cloneDeep } from 'lodash'
import copyNodeMixin from '@/mixins/copyNodeMixin.js'
import { mapGetters } from 'vuex'
import api from '@/api'
export default {
  mixins: [copyNodeMixin],
  data() {
    return {
      loading: false,
      tree: [],
      step: 1,
      show: false,
      page: null,
      pagelist: [],
      flows: [],
      types: [],
      items: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      variable: 'getVariableList',
      loadingVariableList: 'getLoadingVariableList'
    }),
    filterflow() {
      return this.tree.filter(el => {
        return el && !el.toString().includes('notinclude:')
      })
    },
    currentPage() {
      if (!this.page) return null
      return this.pagelist.find(el => {
        return el.botorigin == this.page
      })
    }
  },

  async mounted() {},
  methods: {
    async handleInit() {
      this.loading = true
      await this.$store.dispatch('loadAllVariable')
      await this.getallbotorigins()
      await this.getAllFlow()
      this.types = this.flows
        .reduce((acc, cur) => {
          const type = cur.template

          if (!acc.includes(type) && type != null) acc.push(type)

          return acc
        }, [])
        .sort()
      this.items = this.getTree()
      this.loading = false
    },
    async cloneIntents(intents, flowid, oldflowid, flows) {
      if (intents.length > 0) {
        intents = JSON.parse(JSON.stringify(intents))
        var newNodes = await this.getCopyNode(intents, flowid)
        var updateNodePromise = []
        if (newNodes) {
          newNodes.forEach(el => {
            let replace_flow = null

            if (
              ['node', 'start_node', 'api', 'condition', 'savevariables', 'flow'].includes(el.type)
            ) {
              el.answer[0].forEach((answer, aindex) => {
                if (['text', 'button'].includes(answer.type))
                  el.answer[0][aindex].text = el.answer[0][aindex].text.replaceAll(
                    `flow${oldflowid}.`,
                    `flow${flowid}.`
                  )
                else if (answer.type == 'api') {
                  el.answer[0][aindex].req = el.answer[0][aindex].req.replaceAll(
                    `flow${oldflowid}.`,
                    `flow${flowid}.`
                  )
                  el.answer[0][aindex].update = el.answer[0][aindex].update.replaceAll(
                    `flow${oldflowid}.`,
                    `flow${flowid}.`
                  )
                } else if (answer.type == 'condition') {
                  el.answer[0][aindex].condition.forEach((condition, cindex) => {
                    if (el.answer[0][aindex].condition[cindex].case)
                      el.answer[0][aindex].condition[cindex].case = el.answer[0][aindex].condition[
                        cindex
                      ].case.replaceAll(`flow${oldflowid}.`, `flow${flowid}.`)
                    if (el.answer[0][aindex].condition[cindex].caseText)
                      el.answer[0][aindex].condition[cindex].caseText = el.answer[0][
                        aindex
                      ].condition[cindex].caseText.replaceAll(`flow${oldflowid}.`, `flow${flowid}.`)
                  })
                } else if (el.type == 'savevariables') {
                  el.answer[0][aindex].variables.forEach((variable, vindex) => {
                    el.answer[0][aindex].variables[vindex].text = el.answer[0][aindex].variables[
                      vindex
                    ].text.replaceAll(`flow${oldflowid}.`, `flow${flowid}.`)
                  })
                } else if (el.type == 'flow') {
                  replace_flow = flows.find(flow => {
                    return flow.oldname == el.answer[0][aindex].flowname
                  })

                  if (replace_flow) {
                    el.answer[0][aindex].flowname = replace_flow.flowname
                    // ผิด ต้อง replace ด้วย node id
                    // el.connected_intents[0].to = replace_flow.id
                  }
                }
              })
            }
          })
          if (this.variable) {
            let variables = this.variable.filter(el => {
              return el.flowid == oldflowid
            })

            var new_variables = []

            if (variables && variables.length > 0) {
              let variablePromises = variables.map(variable => {
                return this.cloneVariable(variable, flowid, oldflowid)
              })

              new_variables = await Promise.all(variablePromises)
            }
          }

          updateNodePromise = newNodes.map(node => {
            return this.updateNode(newNodes, node)
          })
          await Promise.all(updateNodePromise)
        }

        return newNodes
      }
    },
    cloneVariable(payload, flowid, oldflowid) {
      return new Promise((resolve, reject) => {
        var data = cloneDeep(payload)
        delete data.id
        data.name = data.name.replace(`flow${oldflowid}.`, `flow${flowid}.`)
        data.flowid = flowid

        api.addVariable(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.data && response.data.length > 0) {
            resolve({ ...response.data[0], oldid: payload.id })
          } else {
            reject()
          }
        })
      })
    },
    cloneGlobalVariable(payload, pageid, oldpageid) {
      return new Promise((resolve, reject) => {
        var data = cloneDeep(payload)
        delete data.id
        data.name = data.name.replace(`${oldpageid}.`, `${pageid}.`)

        api.addVariable(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.data && response.data.length > 0) {
            resolve({ ...response.data[0], oldid: payload.id })
          } else {
            reject()
          }
        })
      })
    },
    updateNode(intents, payload) {
      return new Promise((resolve, reject) => {
        var intent = intents.find(el => {
          return el.id == payload.id
        })

        if (intent) {
          var data = cloneDeep(intent)
          data.x = parseInt(payload.x)
          data.y = parseInt(payload.y)
          data.question = data.question ? data.question : ''
          data.connected_intents = JSON.stringify(data.connected_intents)
          data.answer = JSON.stringify(data.answer)
          data.quick_reply = data.quick_reply ? data.quick_reply : ''
          api.editNode(data, function(error, response) {
            if (error) {
              reject(error)
            }
            resolve()
          })
        } else {
          reject()
        }
      })
    },
    onclose() {
      this.step = 1
      this.page = null
      this.tree = []
      this.show = false
    },
    async oncomplete() {
      var vm = this
      var result = await vm.$swal.fire({
        title: vm.$t('Do you want to transfer this?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })

      this.loading = true

      if (result.value && this.filterflow.length > 0) {
        var flowPromise = []

        for (let index = 0; index < this.filterflow.length; index++) {
          const flowid = this.filterflow[index]
          flowPromise.push(this.cloneFlow(flowid))
        }

        let flows = await Promise.all(flowPromise)

        let allnodes = []
        if (flows) {
          for (let index = 0; index < flows.length; index++) {
            const flow = flows[index]
            var intents = await this.getFlowAllIntents(flow.oldid)
            intents = this.convertJsonToObject(intents)

            let newNodes = await this.cloneIntents(intents, flow.id, flow.oldid, flows)
            allnodes = [...allnodes, ...newNodes]
          }

          try {
            let filterLinkFlow = allnodes
              .filter(el => el.type == 'flow')
              .map(el => {
                let target_node = allnodes.find(node => node.oldid == el.connected_intents[0].to)
                if (target_node) {
                  el.connected_intents[0].to = target_node.id
                  return el
                } else {
                  return null
                }
              })
              .filter(el => el != null)

            if (filterLinkFlow.length > 0) {
              let updateNodePromise = filterLinkFlow.map(node => {
                return this.updateNode(filterLinkFlow, node)
              })
              await Promise.all(updateNodePromise)
            }
          } catch (error) {
            console.error(error)
          }
        }
      }
      await this.$swal.fire({
        type: 'success',
        title: this.$t('Success')
      })
      this.show = false
      this.loading = false
      this.onclose()
    },
    async cloneFlow(flowid) {
      var flow = this.flows.find(el => {
        return el.id == flowid
      })
      if (flow) {
        // var flowname = `${flow.flowname}`
        try {
          var responsenewflow = await this.addNewFlow({
            ...flow,
            // flowname: flowname,
            // template: flow.template,
            x: 0,
            y: 0,
            zoom: 1,
            adminid: this.$store.state.userid,
            pageidlist: this.page
          })

          if (
            responsenewflow &&
            responsenewflow.responsecode == 200 &&
            responsenewflow.data &&
            responsenewflow.data.length > 0
          ) {
            var newflow = responsenewflow.data[0]

            // if (flow.pageidlist) {
            //   let pageidlist = flow.pageidlist.split(',')
            //   if (pageidlist.length > 0) {
            //     let pageid = pageidlist[0]
            //     let variables =
            //       this.variableList && this.variableList.length > 0
            //         ? this.variableList.filter(variable => {
            //             return variable.name.indexOf(pageid + '.') != -1
            //           })
            //         : []
            //     variables.forEach(variable => {
            //       this.cloneGlobalVariable(variable, this.selectedBot.pageid, pageid)
            //     })
            //   }
            // }

            return { ...newflow, oldid: flowid, oldname: flow.flowname }
          }
        } catch (error) {
          console.error(error)
        }
      }
      return Promise.resolve()
    },
    async addNewFlow(data) {
      this.loadingAddFlow = true
      try {
        var response = await api.addFlowDetail(data)

        // await this.$store.dispatch('loadFlowList')
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    convertJsonToObject(intents) {
      return intents.map((intent, index) => {
        var i = intent
        try {
          i.answer = JSON.parse(intent.answer)
        } catch (error) {
          i.answer = []
        }
        try {
          i.connected_intents =
            intent.connected_intents != null ? JSON.parse(intent.connected_intents) : []
        } catch (error) {
          i.connected_intents = []
        }
        i.userinput = {}
        if (i.x == null) {
          i.x = 0
        }
        if (i.y == null) {
          i.y = 0
        }
        return i
      })
    },
    getTree() {
      const children = this.types.map(type => {
        if (type)
          return {
            id: 'notinclude:' + type,
            name: this.getName(type),
            children: this.getChildren(type)
          }
      })
      return [
        {
          id: 'notinclude:all',
          name: 'All Template',
          children
        }
      ]
    },
    async getallbotorigins() {
      var response = await api.getallbotorigins()
      this.pagelist = response.data
    },
    async getAllFlow() {
      var response = await api.getAllFlow()
      this.flows = response.data ? response.data : []
    },
    getChildren(type) {
      const flows = this.flows
        .filter(flow => {
          return flow.template == type && flow.template != null
        })
        .map(el => {
          return {
            ...el,
            name: this.getName(el.flowname)
          }
        })

      return flows.sort((a, b) => {
        return a.flowname > b.flowname ? 1 : -1
      })
    },
    getName(name) {
      return `${name.charAt(0).toUpperCase()}${name.slice(1)}`
    },
    getFlowAllIntents(flowid) {
      return new Promise((resolve, reject) => {
        var data = { flowid: flowid }
        api.getFlowAllIntents(data, function(error, response) {
          if (error) {
            reject(error)
            return
          }
          if (response.data) {
            resolve(response.data)
          } else {
            resolve([])
          }
        })
      })
    }
  },
  watch: {
    show() {
      if (this.show) {
        this.handleInit()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/allbots/TransferFlow.vue